import { render } from "./ExampleImage.vue?vue&type=template&id=b9f5f16c&scoped=true&ts=true"
import script from "./ExampleImage.vue?vue&type=script&lang=ts"
export * from "./ExampleImage.vue?vue&type=script&lang=ts"

import "./ExampleImage.vue?vue&type=style&index=0&id=b9f5f16c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f5f16c"]])

export default __exports__